<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.兴趣标签列表") }}</span>
    </div>

    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button size="medium" round @click="createTarget">
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.新建") }}
          </el-button>
        </el-link>
        <el-link :underline="false">
          <el-button size="medium" round @click.native="refresh">
            <i class="iconfont">&#xe667;</i>
            {{ $t("message.刷新") }}
          </el-button>
        </el-link>
      </div>
    </div>

    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="tagList"
        stripe
        border
        :height="tableHeight"
        style="width: 100%"
      >
        <el-table-column
          fixed
          width="160"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-zoom-in"
                @click="editTarget(scope.row, false)"
              ></el-button>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-edit"
                @click="editTarget(scope.row, true)"
              ></el-button>
              <el-button
                size="mini"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  targetRow = scope.row;
                  deleteDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>

        <el-table-column
 
          prop="id"
          :label="$t('message.兴趣标签ID')"
          width="125"
        >
        </el-table-column>

        <el-table-column
 
          prop="title"
          :label="$t('message.兴趣标签名称')"
          
        >
        </el-table-column>

        <el-table-column
          sortable
          prop="sort"
          :label="$t('message.排序')"
          width="125"
        >
        </el-table-column>

        <el-table-column
          width="150"
          sortable
          :label="$t('message.标签分组')"
          prop="groupid"
        >
          <template slot-scope="scope">
            <span>{{ getGroupName(scope.row.groupid) }}</span>
          </template>
        </el-table-column>



        <el-table-column
          width="100"
          sortable
          :label="$t('message.状态')"
          prop="state"
        >
          <template slot-scope="scope">
            <span>{{ getStateName(scope.row.state) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          sortable
          prop="editdate"
          :label="$t('message.更新日期')"
        >
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该获取方式") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteTarget">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";

export default {
  name: "InterestedTagList",
  components: {
  },
  data() {
    return {
      tableHeight: 500,

      //获取列表
      tagList: [],
      groupList: [],

      deleteDialogVisible: false,
      targetRow: null,
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    refresh() {
      rejecthttp(
        true,
        "get",
        "/manage/interestedtag/grouplist",
        { appid: "188" },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            // 添加总条数
            this.groupList = doc.data.data;
            this.groupList.forEach((any) => {
              any.editdate = commonUtil.formatDate(any.editdate);
            });
          }
        }
      );

      console.log("aaaaaaaaaaa", this.pagingBody);
      rejecthttp(
        true,
        "get",
        "/manage/interestedtag/taglist",
        { appid: "188" },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);

            this.tagList = doc.data.data;
            this.tagList.forEach((any) => {
              any.editdate = commonUtil.formatDate(any.editdate);
            });
          }
        }
      );
    },

    getGroupName(groupid) {
      for (let i = 0; i < this.groupList.length; ++i) {
        if (this.groupList[i].id == groupid) {
          return this.groupList[i].groupname;
        }
      }

      return "未定义";
    },

    createTarget() {
      this.$router.push({ name: "interestedTagDetail", query: { appid: "188" } });
    },

    editTarget(data, edit) {
      this.$router.push({
        name: "interestedTagDetail",
        query: { id: data.id, appid: "188", isEditMode: edit },
      });
    },

    deleteTarget() {
      rejecthttp(
        true,
        "get",
        "/manage/interestedtag/deletetag",
        {
          appid: 188,
          tagid: this.targetRow.id,
        },
        this,
        (doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          }
          this.deleteDialogVisible = false;
          this.refresh();
        }
      );
    },
    getStateName(state) {
      return commonUtil.getStateName(state);
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {
    this.refresh();
  },
  computed: {},
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}

.serachSpan {
  width: 7%;
}
.serachText {
  width: 13%;
}
.serachInput {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/interestedTag/interestedTagList.vue